import {
  Create,
  useNotify,
  SimpleForm,
  useRedirect,
  useStore,
  type CreateProps,
  type RaRecord,
} from "react-admin";
import { NiyaazForm } from "../common/NiyaazForm";
import { validateFamilyMembers, validateMehmaans } from "../common/validate-niyaaz-members";
import { calcTotalPayable, isAsharaEvent } from "@/utils";
import type { NiyaazPayableData } from "@/utils/app-formatters";
import type { CurrentEvent } from "@/containers/events/types";

export const NiyaazCreate = (props: CreateProps) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const onFailure = (error: unknown) => {
    const msg = error instanceof Error ? error.message : String(error);
    notify(`Could not edit post: ${msg}`);
  };

  const [currentEvent] = useStore<CurrentEvent | null>("currentEvent");

  const validateNiyaazCreation = (values: Record<string, unknown>) => {
    const errors: Record<string, unknown> = {};
    if (!values.markaz) {
      errors.markaz = isAsharaEvent(currentEvent ?? undefined)
        ? "The venue is required"
        : "The markaz is required";
    }
    if (!isAsharaEvent(currentEvent ?? undefined) && !values.namaazVenue) {
      errors.namaazVenue = "The namaaz venue is required";
    }
    if (!values.HOFId) {
      errors.HOFId = "The HOF ITS is required";
    }
    if (!values.HOFName) {
      errors.HOFName = "The HOF Name is required";
    }
    const familyMembersError = validateFamilyMembers(
      values.familyMembers as Parameters<typeof validateFamilyMembers>[0],
      true
    );
    if (familyMembersError) {
      errors.familyMembers = familyMembersError;
    }

    if (isAsharaEvent(currentEvent ?? undefined)) {
      const mehmaansError = validateMehmaans(
        values.mehmaans as Parameters<typeof validateMehmaans>[0]
      );
      if (mehmaansError) {
        errors.mehmaans = mehmaansError;
      }
    }
    const paid = Number(values.paidAmount);
    if (paid > 0 && !values.mode) {
      errors.mode = "Payment Mode is Required";
    }
    const totalPayable = calcTotalPayable(currentEvent ?? {}, values as NiyaazPayableData);
    if (paid > totalPayable) {
      errors.paidAmount = "Payment Amount cannot be greater than payable";
    }
    return errors;
  };

  const onSuccess = (data: RaRecord) => {
    notify(`Niyaaz form created - ${String(data.formNo ?? "")}`, {
      autoHideDuration: 5000,
      type: "success",
    });
    redirect("/niyaaz");
  };

  return (
    <Create
      {...({
        ...props,
        onFailure,
        redirect: false,
        mutationOptions: { onSuccess },
      } as CreateProps)}
    >
      <SimpleForm warnWhenUnsavedChanges validate={validateNiyaazCreation} sx={{ maxWidth: 1200 }}>
        <NiyaazForm mode="create" />
      </SimpleForm>
    </Create>
  );
};
